import React from 'react';
import Barrier from "../../../components/pages/grid/Barrier/Barrier";

const BarrierGridPage = () => {
    return <Barrier />
};

export default BarrierGridPage;
